import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ResolveFn } from '@angular/router';
import { switchMap } from 'rxjs';


export const privacyContent: ResolveFn<SafeHtml> = () => {
  const sanitizer = inject(DomSanitizer);
  const http = inject(HttpClient);

  const marked = import('marked');

  return http.get('/assets/public/privacy-policy/privacy-policy.md', { responseType: 'text' })
    .pipe(
      switchMap(async response => {
        const html = (await marked).parse(response);
        return sanitizer.bypassSecurityTrustHtml(await html);
      })
    );
};